import Score from '../../Score/Score';

export default class ScoreNumberOnly extends Score {}
